import { useState } from 'react'
import axios, { AxiosError } from 'axios'
import { RetirementConstraintsResponse } from '@Types'
import { useAlert } from '@apex/component-library'
import { useFormatMessage } from '../utils/intlHelpers'
import { HttpResponseStatusCodes } from '../constants'

export const useIraConstraints = (iraConstraintsUrl: string) => {
  const [constraintData, setData] = useState<RetirementConstraintsResponse>()
  const [constraintError, setError] = useState<boolean>(false)
  const [constraintLoading, setLoading] = useState<boolean>(false)
  const { setAlert } = useAlert()
  const formatMessage = useFormatMessage()

  const getIraConstraints = () => axios.get(iraConstraintsUrl, { withCredentials: true })

  const handleChange = () => {
    setLoading(true)
    getIraConstraints()
      .then((response) => {
        const { data } = response
        setData(data)
        setError(false)
        setLoading(false)
      })
      .catch((err: AxiosError) => {
        setError(true)
        setLoading(false)
        let statusCode = err.response?.status
        if (statusCode && statusCode >= HttpResponseStatusCodes.InternalServerError) {
          setAlert({
            title: formatMessage('common.systemUnavailable'),
            description: formatMessage('common.serviceUnavailable'),
            status: 'error',
            direction: 'row',
            isClosable: true,
            showIcon: true
          })
        }
      })
  }
  return { handleChange, constraintData, constraintError, constraintLoading }
}
